<template>
  <div>
    <ContentHeader />
    <div class="content-container">
      <ItemOrderTemplate :has-btn="false" />
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import ItemOrderTemplate from './components/item-order-template'
export default {
  name: 'MenuListTemplate',
  components: {
    ContentHeader,
    ItemOrderTemplate
  },
  methods: {}
}
</script>
